export default __webpack_public_path__ + "static/media/kendra_losee.c3112da2.png";